/**
 * @generated SignedSource<<4230a09192e7b8576253c6e3344b7ed0>>
 * @relayHash 3bc22a19b7e4388cf4e2ded6f764d99a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 92e187353ccc998aef9dc268068502b21c671e33e8556549b51a338719a28ef5

import type { ConcreteRequest } from 'relay-runtime';
export type useContentByLabelDataQuery$variables = {
  cql: string;
  fallbackToBody: boolean;
  first?: number | null;
  includeExcerpt: boolean;
  maxExcerptBlocks?: number | null;
  skipContentTitle?: boolean | null;
  skipSearchTitle?: boolean | null;
};
export type useContentByLabelDataQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly body?: {
          readonly atlas_doc_format: {
            readonly mediaToken: {
              readonly token: string | null;
            } | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly name: string | null;
          } | null> | null;
        } | null;
        readonly macroExcerpt?: {
          readonly atlasDocFormat: string | null;
        } | null;
        readonly space: {
          readonly id: string | null;
          readonly key: string | null;
          readonly name: string | null;
        } | null;
        readonly subType: string | null;
        readonly title?: string | null;
        readonly type: string | null;
      } | null;
      readonly lastModified: string | null;
      readonly title?: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
};
export type useContentByLabelDataQuery = {
  response: useContentByLabelDataQuery$data;
  variables: useContentByLabelDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fallbackToBody"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeExcerpt"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxExcerptBlocks"
},
v5 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skipContentTitle"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skipSearchTitle"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "title"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = [
  {
    "alias": "search",
    "args": [
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSearchResponse",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "condition": "skipSearchTitle",
            "kind": "Condition",
            "passingValue": false,
            "selections": (v7/*: any*/)
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "lastModified"
          },
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "condition": "skipContentTitle",
                "kind": "Condition",
                "passingValue": false,
                "selections": (v7/*: any*/)
              },
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "subType"
              },
              {
                "condition": "includeExcerpt",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ConfluenceMacroExcerptBody",
                    "kind": "LinkedField",
                    "name": "macroExcerpt",
                    "plural": false,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "fallbackToBody",
                            "variableName": "fallbackToBody"
                          },
                          {
                            "kind": "Variable",
                            "name": "maxBlocks",
                            "variableName": "maxExcerptBlocks"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "atlasDocFormat"
                      }
                    ]
                  },
                  {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "atlas_doc_format",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "EmbeddedMediaToken",
                            "kind": "LinkedField",
                            "name": "mediaToken",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "token"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  (v9/*: any*/)
                ]
              },
              {
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentByLabelDataQuery",
    "selections": (v10/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentByLabelDataQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "3bc22a19b7e4388cf4e2ded6f764d99a",
    "id": "92e187353ccc998aef9dc268068502b21c671e33e8556549b51a338719a28ef5",
    "metadata": {},
    "name": "useContentByLabelDataQuery",
    "operationKind": "query",
    "text": "query useContentByLabelDataQuery($cql:String!,$first:Int,$includeExcerpt:Boolean!,$fallbackToBody:Boolean!,$maxExcerptBlocks:Int,$skipSearchTitle:Boolean=false,$skipContentTitle:Boolean=true){search:confluence_search(cql:$cql,first:$first){nodes{title@skip(if:$skipSearchTitle),url,lastModified,content{id,title@skip(if:$skipContentTitle),type,subType,macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:$fallbackToBody,maxBlocks:$maxExcerptBlocks)}\n        body@include(if:$includeExcerpt){atlas_doc_format{mediaToken{token}}},space{id,key,name},labels{nodes{id,name}}}}}}"
  }
};
})();

(node as any).hash = "1940c9c67b38d6b805a9e38cba96bfab";

export default node;
